// extracted by mini-css-extract-plugin
export default {"text":"GradientText-module--text--1gTyR"};